import * as Sentry from '@sentry/react';
import axios from 'axios';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './app.component';
import { IEnvironment } from './shared';

const initializeApp = async () => {
    const { data: environment } = await axios.get<IEnvironment>(`/environment`);
    window.carity = { environment };

    if (environment.theme.externalStylesheets) {
        environment.theme.externalStylesheets.forEach((stylesheet) => {
            const linkTag = document.createElement('link');
            linkTag.setAttribute('rel', 'stylesheet');
            linkTag.setAttribute('href', stylesheet);
            document.head.append(linkTag);
        });
    }

    Sentry.init({
        enabled: environment.sentryEnabled,
        dsn: environment.sentryUrl,
        environment: environment.sentryEnvironment,
    });
};

const root = createRoot(document.getElementById('root') as HTMLElement, {
    onUncaughtError: Sentry.reactErrorHandler((e) => Sentry.captureException(e)),
    onCaughtError: Sentry.reactErrorHandler((e) => Sentry.captureException(e)),
});

initializeApp().finally(() =>
    root.render(
        <React.StrictMode>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </React.StrictMode>,
    ),
);
